import type { AnchorHTMLAttributes, MouseEvent } from 'react';
import { localizeHref, navigate } from '../app/router.ts';

/** <a> that navigates client-side while keeping normal link behaviour (new tab, copy link). */
export function Link({ href, onClick, ...rest }: AnchorHTMLAttributes<HTMLAnchorElement> & { href: string }) {
  const handle = (e: MouseEvent<HTMLAnchorElement>) => {
    onClick?.(e);
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    e.preventDefault();
    navigate(href);
  };
  return <a href={localizeHref(href)} onClick={handle} {...rest} />;
}
